export function doDrawIcon(
  ctx,
  src,
  srcleft,
  scrtop,
  srcWidth,
  srcHeight,
  dstLeft,
  dstTop,
  destWidth,
  destHeight,
  disableSmooth
) {
  ctx.imageSmoothingEnabled = !disableSmooth; // turn off when we have good images
  ctx.drawImage(src, srcleft, scrtop, srcWidth, srcHeight, dstLeft, dstTop, destWidth, destHeight);
}
